import { tr } from "../../i18n";
/**
 * TeamBadge — renderizza il logo personalizzato della squadra se presente,
 * altrimenti le iniziali come fallback (gradient viola/oro).
 *
 * Andrea 2026-05-20: il presidente puo' caricare un logo da Gestione Rosa.
 * Usato in Dashboard MatchCard, Classifica, ovunque servano badge squadra.
 */

interface TeamBadgeProps {
  nome: string;
  logoDataUrl: string | null | undefined;
  /** Dimensione del badge in px (default 48). */
  size?: number;
  /** Variante stile: "home" (gradient pieno) o "away" (bordo accent). */
  variant?: "home" | "away";
  className?: string;
}

function computeInitials(nome: string): string {
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function TeamBadge({
  nome,
  logoDataUrl,
  size = 48,
  variant = "home",
  className = "",
}: TeamBadgeProps) {
  const px = `${size}px`;
  // Logo presente → mostra l'immagine (cover, no stretch)
  if (logoDataUrl) {
    // Andrea 2026-06-15: niente riquadro scuro attorno al logo. Sfondo
    // trasparente + object-contain → il PNG (anche con angoli trasparenti) si
    // fonde col colore sotto (card viola in dashboard, card scura altrove).
    return (
      <div className={`mx-auto overflow-hidden ${className}`} style={{ width: px, height: px }}>
        <img
          src={logoDataUrl}
          alt={tr("Logo {{v1}}", { v1: nome })}
          className="w-full h-full object-contain"
          loading="lazy"
        />
      </div>
    );
  }
  // Fallback iniziali
  const initials = computeInitials(nome);
  const styleClasses =
    variant === "home"
      ? "bg-gradient-to-br from-primary to-primary-deep text-accent"
      : "bg-gradient-to-br from-primary-deep to-bg-card border border-accent/30 text-accent-soft";
  return (
    <div
      className={`mx-auto rounded-card flex items-center justify-center font-display ${styleClasses} ${className}`}
      style={{ width: px, height: px, fontSize: `${Math.round(size * 0.42)}px` }}
    >
      {initials}
    </div>
  );
}
